import React, { useContext, useMemo, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Login.css";
import Bannerone from "../Images/banner.png";
import Bannertwo from "../Images/banner2.svg";
import Bannerthree from "../Images/banner3.svg";
import Imagenine from "../Images/image9.png";
import Imageoneab from "../Images/image1.jpeg";
import Imagetwenty from "../Images/image2.jpeg";
import Imageone from "../Images/image1.jpeg";
import Imagetwo from "../Images/image2.jpeg";
import Imagethree from "../Images/image3.png";
import Imagefor from "../Images/image4.jpeg";
import Imagefive from "../Images/image5.jpeg";
import Imagesix from "../Images/image6.jpeg";
import Imageseven from "../Images/image7.jpeg";
import Imageeight from "../Images/image8.jpeg";
import Imageten from "../Images/image9.jpeg";
import Imageeleven from "../Images/image11.jpeg";
import Imagetweleve from "../Images/image12.jpeg";
import Imagethreteen from "../Images/image13.jpeg";
import Imageforteen from "../Images/image14.jpeg";
import Imagefifteen from "../Images/image15.jpeg";
import NHAM from "../Images/NHM-black 2.png";
import NHP from "../Images/NHM-black 2.png";
import MYGOV from "../Images/Ministry_of_Health_India.svg";
import NHSRC from "../Images/NHSRC.png";
import Ministryofhelth from "../Images/Ministry_of_Health_India.svg";
import NPPCD from "../Images/NPPCD_logo.png";
import { height } from "@mui/system";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NCDicon from "../Images/NCD.svg";
import { useNavigate } from "react-router-dom";
import { CommonContext } from "../../context/CommonContext";
import { AuthContext } from "../../context/AuthContext";
import http, { authHttp } from "../../services/commonHttpService";
import { apisPath, paths } from "../../utils/path";
import { encrypt } from "../../helpers/encryptDecrypt";
import { Formik } from "formik";
import * as Yup from "yup";
import { generateCaptcha } from "../../helpers/commonHelper";
import { getDashboardPath } from "../../config/rolesConfig";
import { Button, TextField } from "@mui/material";
import RibbonImg from "../../Images/ribbon.png"

const defaultValues = {
  username: "",
  password: "",
  captcha: "",
};

const createLoginSchema = (captchaValue) =>
  Yup.object().shape({
    username: Yup.string()
      .required("Username is required")
      .test(
        "no-only-spaces",
        "Username cannot be only spaces",
        (value) => value && value.trim().length > 0
      )
      .max(100, "Username must be less than or equal to 100 characters"),
    // .matches(
    //   REGEXS.alplabhetNumeric,
    //   "Please enter a valid Username"
    // ),

    password: Yup.string()
      .required("Password is required")
      .test(
        "no-only-spaces",
        "Password cannot be only spaces",
        (value) => value && value.trim().length > 0
      ),
    captcha: Yup.string()
      .required("Captcha is required")
      .test(
        "no-only-spaces",
        "Captcha cannot be only spaces",
        (value) => value && value.trim().length > 0
      )
      .oneOf([captchaValue], "Captcha is not correct"),
  });

const Homepage = () => {
  const [carouselIndex, setCarouselIndex] = useState(0);
  const images = [Imageoneab, Imagetwenty];
  const [showLoginModal, setShowLoginModal] = useState(false);

  //login
  const navigate = useNavigate();
  const { setIsLoading, setAlertState } = useContext(CommonContext);
  const { login, setUserName } = useContext(AuthContext);
  const [securedCaptcha, setSecuredCaptcha] = useState(generateCaptcha);
  const [error, setError] = useState("");
  const [captchaFocus, setCaptchaFocus] = useState(false);

  const updateCarousel = (i) => setCarouselIndex(i);
  const nextImage = () =>
    setCarouselIndex((prev) => (prev + 1) % images.length);
  const prevImage = () =>
    setCarouselIndex((prev) => (prev - 1 + images.length) % images.length);

  const LoginSchema = useMemo(
    () => createLoginSchema(securedCaptcha),
    [securedCaptcha]
  );

  const handleLogin = async (data, { resetForm }) => {
    setIsLoading(true);
    setError("");

    try {
      // Step 1: Login API call
      const loginResponse = await http.post(apisPath?.login, {
        username: data?.username,
        password: data?.password,
        captcha: data?.captcha,
      });

      if (loginResponse?.data?.success && loginResponse?.data?.token) {
        const token = loginResponse?.data?.token;
        const userId = loginResponse?.data?.user?.user_id;
        const userName = loginResponse?.data?.user?.fullName;
        const facilityId = loginResponse?.data?.user?.facility_id;

        // Step 2: Encrypt and store token with expiry time (30 minutes)
        const encryptedToken = encrypt(token);
        // const expiryTime = Date.now() + 10 * 60 * 1000; // 10 minutes from now
        const expiryTime = Date.now() + 30 * 60 * 1000; // 60 minutes from now
        const encryptedExpiry = encrypt(expiryTime.toString());

        // Store encrypted token and expiry time
        await localStorage.setItem("app-token", JSON.stringify(encryptedToken));
        await localStorage.setItem(
          "token-expiry",
          JSON.stringify(encryptedExpiry)
        );

        // Step 3: Encrypt and store userId
        const encryptedUserId = encrypt(userId.toString());
        await localStorage.setItem("user-id", JSON.stringify(encryptedUserId));

        // Step 3: Encrypt and store userName
        const encryptedUserName = encrypt(userName.toString());
        await localStorage.setItem("user-name", JSON.stringify(encryptedUserName));

        // Step 4: Encrypt and store facilityId
        const encryptedFacilityId = encrypt(facilityId.toString());
        await localStorage.setItem("facility-id", JSON.stringify(encryptedFacilityId));

        // Step 5: Fetch user profile to get role
        const profileResponse = await authHttp.get(
          `${apisPath?.userProfile}/${userId}`
        );

        if (profileResponse?.data?.success) {
          const roleId = profileResponse?.data?.data?.role?.role_id;
          // const roleId = 1;

          // Step 5: Encrypt and store user role ID
          const encryptedRole = encrypt(roleId.toString());
          await localStorage.setItem(
            "user-role",
            JSON.stringify(encryptedRole)
          );

          // Step 6: Update AuthContext with login status
          await login(encryptedToken, encryptedRole, encryptedUserId, encryptedFacilityId, encryptedUserName);

          // Step 7: Navigate to role-specific dashboard
          const dashboardPath = getDashboardPath(roleId);
          setIsLoading(false);
          navigate(
            `${paths?.user?.commonPoint}${paths?.user?.[dashboardPath]}`
          );
        } else {
          throw new Error("Failed to fetch user profile");
        }
      } else {
        throw new Error(loginResponse?.data?.message || "Login failed");
      }
    } catch (err) {
      console.error("Login Error:", err);
      setIsLoading(false);

      setAlertState((prev) => ({
        ...prev,
        open: true,
        title:
          err?.response?.data?.message ||
          err?.message ||
          "Login failed. Please try again.",
        btnTxt: "CLOSE",
        status: "fail",
      }));

      resetForm();
      setSecuredCaptcha(generateCaptcha());
    }
  };

  return (
    <div className="newHeader">
      {/* HEADER */}
      <header className="top-header py-4" id="top">
        <div className="container">
          {/* Left Logo */}
          <div className="d-flex align-items-center">
            <img src={Ministryofhelth} className="gov-logo" alt="Gov Logo" />
          </div>

          {/* Center Title */}
          <h5 className="header-title text-center m-0">
            Day Care Cancer Center (DCCC)
          </h5>

          {/* Right Logos */}
          <div className="logo-group">
            {/* <img
              src={NPPCD}
              className="nic-logo"
              alt="NPPCD Logo"
              style={{ height: "60px" }}
            /> */}
            <img src={NHAM} className="nic-logo" alt="NHAM Logo" />
          </div>
        </div>
      </header>

      {/* NAVBAR */}
      <nav className="navbar navbar-expand-lg navbar-dark navbar-purple sticky-top">
        <div className="container">
          <button
            className="navbar-toggler"
            data-bs-toggle="collapse"
            data-bs-target="#navMenu"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navMenu">
            <ul className="navbar-nav nav-custom-mar text-center">
              <li className="nav-item">
                <a className="nav-link active" href="#top">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#about-dccc">
                  About DCCC
                </a>
              </li>
            </ul>

            <div className="d-flex align-items-center ms-auto gap-3">
              <button
                className="Login-btn"
                onClick={() =>
                  window.open("https://ncd.mohfw.gov.in/", "_blank")
                }
              >
                <ArrowBackIcon className="me-1" />
                NCD
              </button>

              <button
                className="Login-btn"
                onClick={() => setShowLoginModal(true)}
              >
                Login
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* HERO IMAGE */}
      <section className="hero-section" id="about-dccc">
        <div
          id="heroCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="3000"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide-to="0"
              className="active cust-dots"
            ></button>
            <button
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide-to="1"
              className="cust-dots"
            ></button>
            <button
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide-to="2"
              className="cust-dots"
            ></button>
          </div>

          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                src={Bannerone}
                className="d-block w-100 hero-img"
                alt="Banner 1"
              />
            </div>
            <div className="carousel-item">
              <img
                src={Bannerthree}
                className="d-block w-100 hero-img"
                alt="Banner 2"
              />
            </div>
            <div className="carousel-item">
              <img
                src={Bannertwo}
                className="d-block w-100 hero-img"
                alt="Banner 3"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section className="my-5" id="about-dccc">
        <div className="about-wrapper container">
          <div
            className="about-img-background"
            style={{ position: "relative" }}
          >
            <img src={Imagenine} alt="Background" />
          </div>

          <div className="row align-items-center">
            {/* LEFT CAROUSEL */}
            <div className="col-md-5 position-relative">
              <img
                id="carouselMain"
                src={images[carouselIndex]}
                className="carousel-main"
                alt="Main"
              />
              <button
                className="carousel-btn carousel-prev"
                onClick={prevImage}
              >
                ❮
              </button>
              <button
                className="carousel-btn carousel-next"
                onClick={nextImage}
              >
                ❯
              </button>

              <div className="thumb-row">
                {images.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    className={`thumb ${i === carouselIndex ? "active" : ""}`}
                    onClick={() => updateCarousel(i)}
                    alt={`thumb ${i}`}
                  />
                ))}
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-md-7">
              <h3 className="fw-bold text-purple">About DCCC</h3>
              <p className="text-muted text-p">
                Cancer is a leading cause of morbidity and mortality in India,
                with a steadily rising incidence rate. The most common cancers
                in India include: Breast Cancer 14.8%, Cervical Cancer 5.4%,
                Lung Cancer 5.3%, Colorectal Cancer 4.7%, Oral Cancers 10.3%
                (including lip and oral cavity cancers) of all cancers. Gender
                and Regional Distribution: Among women, breast, cervical, and
                ovarian cancers constitute over 50% of all cancer cases. In men,
                oral, lung, stomach, and colorectal cancers are predominant.
                Over 70% of cancer patients present with advanced-stage disease
                due to late diagnosis, predominantly in rural and underserved
                regions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* VERTICAL CAROUSELS */}
      <section className="custom-section">
        <div className="container for-mpbile">
          <div className="row container-last">
            <div className="col-md-7">
              <div className="row">
                {[
                  [Imageone, Imagetwo, Imagethree, Imagefor, Imagefive],
                  [Imagesix, Imageseven, Imageeight, Imageten, Imageeleven],
                  [
                    Imagetweleve,
                    Imagethreteen,
                    Imageforteen,
                    Imagefifteen,
                    Imageone,
                  ],
                ].map((columnImages, colIndex) => (
                  <div key={colIndex} className="col-4">
                    <div
                      className={`vertical-carousel ${colIndex % 2 === 0 ? "top-bottom" : "bottom-top"
                        }`}
                    >
                      <div className="vertical-track">
                        {[...columnImages, ...columnImages].map((img, i) => (
                          <img key={i} src={img} alt={`vertical ${i}`} />
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT TEXT */}
            <div className="col-md-5 mt-4 mt-md-0">
              <p className="custom-para">
                India’s cancer care landscape is evolving to meet the growing
                demand for accessible and affordable treatment. Currently, most
                comprehensive cancer centres (CCCs) and specialized care
                facilities are concentrated in metropolitan cities, leaving
                rural and semiurban populations with limited access to quality
                care. Cancer treatment services available in only 5% of district
                hospitals. This geographical disparity highlights the need for
                decentralization to ensure that life saving treatment reaches
                underserved communities. Establishing Day Care Cancer Centres
                (DCCCs) can play a transformative role in addressing this gap by
                bringing specialized cancer care closer to patients.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PARTNERS BAR */}
      <section>
        <div className="partners-bar mt-4">
          <div className="logos-scroll">
            <div className="logos-track">
              {[NHAM, NHP, MYGOV, NHAM, NHP, NHSRC, MYGOV, NHP, NHAM, NHP, MYGOV, NHAM, NHP, NHSRC, MYGOV, NHP, NHAM,].map((logo, i) => (
                <React.Fragment key={i}>
                  <div className="logo-item">
                    <img src={logo} alt={`logo ${i}`} />
                  </div>
                  <div className="divider"></div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </section>

      {showLoginModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          aria-hidden="true"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content login-modal-box position-relative">
              <button
                type="button"
                className="close-btn"
                onClick={() => setShowLoginModal(false)}
              >
                &times;
              </button>

              <div className="modal-body custom-modal">
                <div className="login-card">
                  <div className="text-center mb-3">
                    {/* <div className="d-flex justify-content-center align-items-center gap-2 mt-2">
                      <img src={NCDicon} width="45" alt="NCD Logo" />
                    </div> */}
                    <div className="d-flex justify-content-center align-items-center gap-2 mt-2">
                      <img src={RibbonImg} width="45" alt="Ribbon" />
                      <h4 className="fw-bold m-0">TCCC & DCCC Login</h4>
                    </div>
                    <p className="text-muted mt-1">
                      Sign in to access your dashboard
                    </p>
                  </div>

                  <Formik
                    initialValues={defaultValues}
                    validationSchema={LoginSchema}
                    onSubmit={handleLogin}
                  >
                    {({
                      handleChange,
                      values,
                      handleSubmit,
                      errors,
                      touched,
                      handleBlur,
                      setFieldValue,
                      isValid,
                      isSubmitting,
                      dirty,
                    }) => (
                      <>
                        <TextField
                          label="Username"
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          size="small"
                          name="username"
                          value={values?.username}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(errors?.username && touched?.username)}
                          helperText={touched?.username && errors?.username}
                          autoComplete="off"
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          sx={{
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              { borderColor: "#0048ff" },
                            "& .MuiInputLabel-root.Mui-focused": {
                              color: "#0048ff",
                            },
                          }}
                        />

                        <TextField
                          label="Password"
                          type="password"
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          size="small"
                          name="password"
                          value={values?.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(errors?.password && touched?.password)}
                          helperText={touched?.password && errors?.password}
                          autoComplete="off"
                          // onPaste={(e) => e.preventDefault()}
                          // onDrop={(e) => e.preventDefault()}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          sx={{
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              { borderColor: "#0048ff" },
                            "& .MuiInputLabel-root.Mui-focused": {
                              color: "#0048ff",
                            },
                          }}
                        />

                        {/* CAPTCHA BOX */}
                        <div
                          className={`captcha-wrapper ${captchaFocus ? "captcha-active" : ""
                            }`}
                        >
                          <div className="captcha-img-react">
                            {securedCaptcha}
                          </div>

                          <input
                            type="text"
                            className="captcha-input"
                            placeholder="Enter captcha"
                            name="captcha"
                            value={values?.captcha}
                            onChange={handleChange}
                            onBlur={(e) => {
                              handleBlur(e);
                              setCaptchaFocus(false);
                            }}
                            onFocus={() => setCaptchaFocus(true)}
                            autoComplete="off"
                            onPaste={(e) => e.preventDefault()}
                            onDrop={(e) => e.preventDefault()}
                            maxLength={6}
                          />
                        </div>

                        {errors?.captcha && touched?.captcha && (
                          <p className="captcha-error">{errors?.captcha}</p>
                        )}

                        <Button
                          variant="contained"
                          fullWidth
                          className="login-btn"
                          onClick={handleSubmit}
                          disabled={!(isValid && dirty) || isSubmitting}
                        >
                          Sign In to Dashboard
                        </Button>
                      </>
                    )}
                  </Formik>

                  <p className="footer-text mt-4 text-center">
                    © All right reserved by Ministry of Health & Family Welfare,
                    <br />
                    Government Of India.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* FOOTER */}
      <footer className="site-footer">
        <p className="footer-text">
          © All right reserved Ministry of Health & Family Welfare, Government
          Of India.
        </p>
      </footer>
    </div>
  );
};

export default Homepage;
